import { Answer } from "../../types/types";
import InitPerson from "../InitPerson";
interface AdressPanelProps {
  correctPositions: Answer[];
  getCallImg: (id: number) => string;
  currentTask: number;
  statusError: Record<number, "noSelect" | "true" | "false">;
}
const personMap = Object.fromEntries(InitPerson.map((p) => [p.id, p]));
const AdressPanel: React.FC<AdressPanelProps> = ({
  correctPositions,
  getCallImg,
  currentTask,
  statusError,
}) => {
  const correctMap = Object.fromEntries(
    correctPositions.map((p) => [
      p.idCharecter,
      p.position ? `${p.position.column}${p.position.roomId}` : "",
    ]),
  );

  const visibleTasks = correctPositions.slice(0, currentTask);

  return (
    <div className="hotel-panel">
      {visibleTasks.map((task) => {
        const id = task.idCharecter;
        const person = personMap[id];
        return (
          <div key={id} className="hotel-row">
            <div className="hotel-avatardiv">
              {statusError[id] !== "true"?"?":<img src={person?.svgUrl} className="hotel-avatar" alt="" />}
            </div>

            <input
              data-testid="answer-input"
              value={correctMap[id] || ""}
              className="hotel-input"
              readOnly
            />

            <div className="hotel-call">
              <img alt="" src={getCallImg(id)} className="hotel-callImg" />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdressPanel;
